import { QuizIdentificationMode } from 'app/types'
import { logToAnalytics } from 'modules'

// Playback-side quiz events only (creation/editing events live in the producer web app).
// Event names match the producer tracker so both surfaces report into the same Mixpanel events.

type QuizAttemptStartedProps = {
    playbookId: string
    quizId: string
    questionCount: number
}

type QuizAttemptSubmittedProps = {
    playbookId: string
    quizId: string
    correctCount: number
    totalQuestions: number
    isPassed: boolean
    attemptNumber: number
}

type QuizWithIdsProps = {
    playbookId: string
    quizId: string
}

type QuizReviewGuideClickedProps = {
    playbookId: string
}

type QuizIdentificationSubmittedProps = {
    playbookId: string
    quizId: string
    hasEmail: boolean
    hasName: boolean
}

type QuizIdentificationSkippedProps = {
    playbookId: string
    quizId: string
    identificationMode: QuizIdentificationMode
}

export const QuizAnalytics = {
    attemptStarted(props: QuizAttemptStartedProps): void {
        logToAnalytics('quiz_attempt_started', props)
    },
    attemptSubmitted(props: QuizAttemptSubmittedProps): void {
        logToAnalytics('quiz_attempt_submitted', props)
    },
    retakeClicked(props: QuizWithIdsProps): void {
        logToAnalytics('quiz_retake_clicked', props)
    },
    rewatchClicked(props: QuizWithIdsProps): void {
        logToAnalytics('quiz_rewatch_clicked', props)
    },
    skipped(props: QuizWithIdsProps): void {
        logToAnalytics('quiz_skipped', props)
    },
    reviewGuideClicked(props: QuizReviewGuideClickedProps): void {
        logToAnalytics('quiz_review_guide_clicked', props)
    },
    identificationSubmitted(props: QuizIdentificationSubmittedProps): void {
        logToAnalytics('quiz_identification_submitted', props)
    },
    identificationSkipped(props: QuizIdentificationSkippedProps): void {
        logToAnalytics('quiz_identification_skipped', props)
    },
}
